module.exports = "<div class=\"geo-blocked-content\">\n  <br>\n  <h1>SORRY :(</h1>\n  <div>\n      <h3>This service is only available in Turkey</h3>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/shared/geo-blocked/geo-blocked.component.html
// module id = ../../../../../src/app/shared/geo-blocked/geo-blocked.component.html
// module chunks = main